import {
    createReducer,
    on
} from '@ngrx/store';
import {
    BadResponseWithError
} from '../../../shared/models/bad-response-with-error.interface';
import {
    Helper
} from '../../../shared/utils/utils';
import {
    CommunicationChat,
    CommunicationChatMessage, CommunicationChatMessagePin,
    CommunicationChatMessages,
} from '../../models/api/responses/chat.response';
import {
    CommunicationChatActions
} from '../actions/actions-type.action';

export interface ChatState {
    chats: CommunicationChat[] | null;
    currentChat: CommunicationChat | null;
    currentChatMessages: CommunicationChatMessages | null;
    pinnedChatMessages: CommunicationChatMessagePin[] | null;
    currentEditedMessage: CommunicationChatMessage | null;
    currentReplyingMessage: CommunicationChatMessage | null;
    error: BadResponseWithError | null;
    isLoading: boolean;
}

const initialState: ChatState = {
    chats: null,
    currentChat: null,
    currentChatMessages: null,
    pinnedChatMessages: null,
    currentEditedMessage: null,
    currentReplyingMessage: null,
    error: null,
    isLoading: false,
};

export const communicationChatReducer = createReducer(initialState, on(CommunicationChatActions.fetchChatsByTargetId, (state, action) => ({
        ...state,
        chats: null,
        isLoading: true,


    })), on(CommunicationChatActions.fetchChatsByTargetIdSuccess, (state, action) => {
        const chats = Helper.deepCopy <CommunicationChat[]>(action.payload);
        const stageMapping: Record<string, string> = {
            'Grand Final': 'Grand Finals',
            'Quarter Final': 'Stage 2',
            'Semi Final': 'Stage 3',
            Group: 'Stage 1',
            Final: 'Stage 4',
            Qualifiers: 'Overall Qualifiers'
        };
        chats.forEach((item) => {
            const pattern = new RegExp(Object.keys(stageMapping)
                .map(key => `${key}`)
                .join('|'), 'g');
            item.name = item.name.replace(pattern, (match: string) => stageMapping[match] || match);
        });
        return {
            ...state,
            chats,
            isLoading: false,
        }
    }),
    on(CommunicationChatActions.fetchChatsByTargetIdFailure, (state, action) => ({
        ...state,
        error: action.payload,
        isLoading: false,
    })), on(CommunicationChatActions.fetchChatInfo, (state, action) => ({
        ...state,
        currentChat: null,
        currentChatMessages: null,
        isLoading: true,
    })), on(CommunicationChatActions.fetchChatInfoSuccess, (state, action) => ({
        ...state,
        currentChat: action.payload,
        isLoading: false,
    })), on(CommunicationChatActions.fetchChatInfoFailure, (state, action) => ({
        ...state,
        error: action.payload,
        isLoading: false,
    })), on(CommunicationChatActions.fetchChatMessages, (state, action) => ({
        ...state,
        isLoading: true,
    })), on(CommunicationChatActions.fetchChatMessagesSuccess, (state, action) => {
        const messages = Helper.deepCopy <CommunicationChatMessage[]>(action.payload.response.messages).reverse();
        const combinedMessages = [...messages, ...state.currentChatMessages?.messages || []];
        const existed = new Set();
        const mergedMessages = combinedMessages.filter(item => {
            if (existed.has(item.messageId)) {
                return false;
            } else {
                existed.add(item.messageId);
                return true;
            }
        });

        return {
            ...state,
            currentChatMessages: action.payload.patchMessages
                ? {
                    ...action.payload.response,
                    messages: [
                        ...mergedMessages
                    ],
                }
                : {
                    ...action.payload.response,
                    messages,
                },
            isLoading: false,
        };
    }), on(CommunicationChatActions.fetchChatMessagesFailure, (state, action) => ({
        ...state,
        isLoading: false,
    })),


    on(CommunicationChatActions.fetchPinnedChatMessages, (state, action) => ({
        ...state,
        isLoading: true,
    })), on(CommunicationChatActions.fetchPinnedChatMessagesSuccess, (state, action) => ({
        ...state,
        pinnedChatMessages: [
            ...action.payload.response,
        ],
        isLoading: false,
    })), on(CommunicationChatActions.fetchPinnedChatMessagesFailure, (state, action) => ({
        ...state,
        isLoading: false,
    })),

    on(CommunicationChatActions.setChatMessageToUpdate, (state, action) => ({
        ...state,
        currentEditedMessage: action.payload.message
    })),
    on(CommunicationChatActions.updateChatMessage, (state, action) => ({
        ...state,
        isLoading: true,
    })), on(CommunicationChatActions.updateChatMessageSuccess, (state, action) => {
        const messages = state.currentChatMessages?.messages || [];
        const updatedMessage = action.payload.response;
        const currentChatMessages = state.currentChatMessages as CommunicationChatMessages;
        return {
            ...state,
            currentChatMessages: {
                ...currentChatMessages,
                messages: messages.map((message) => message.messageId === updatedMessage.messageId ? updatedMessage : message),
            },
            currentEditedMessage: null,
            isLoading: false,
        };
    }), on(CommunicationChatActions.updateChatMessageFailure, (state, action) => ({
        ...state,
        currentEditedMessage: null,
        isLoading: false,
    })),


    on(CommunicationChatActions.pinChatMessage, (state, action) => ({
        ...state,
        isLoading: true,
    })), on(CommunicationChatActions.pinChatMessageSuccess, (state, action) => ({
        ...state,
        pinnedChatMessages: [
            ...action.payload.pinnedMessages,
        ],
        isLoading: false,
    })), on(CommunicationChatActions.pinChatMessageFailure, (state, action) => ({
        ...state,
        isLoading: false,
    })),

    on(CommunicationChatActions.deleteChatMessage, (state, action) => ({
        ...state,
        isLoading: true,
    })),
    on(CommunicationChatActions.deleteChatMessageSuccess, (state, action) => {
        const currentChatMessages = state.currentChatMessages as CommunicationChatMessages
        const newCurrentMessages = state.currentChatMessages?.messages.filter((message) => message.messageId !== +action.payload.messageId) as CommunicationChatMessage[];
        return {
            ...state,
            currentChatMessages: {
                ...currentChatMessages,
                messages: newCurrentMessages,
            },
            isLoading: false,
        }


    }), on(CommunicationChatActions.deleteChatMessageFailure, (state, action) => ({
        ...state,
        isLoading: false,
    })),

    on(CommunicationChatActions.setChatMessageToReply, (state, action) => ({
        ...state,
        currentReplyingMessage: action.payload.message
    })),
    on(CommunicationChatActions.abortReplyToMessage, (state, action) => ({
        ...state,
        currentReplyingMessage: null
    })),
    on(CommunicationChatActions.abortEditMessage, (state, action) => ({
        ...state,
        currentEditedMessage: null
    })),
    on(CommunicationChatActions.replyToChatMessage, (state, action) => ({
        ...state,
        isLoading: true,
    })),
    on(CommunicationChatActions.replyToChatMessageSuccess, (state, action) => ({
        ...state,
        currentReplyingMessage: null,
    })),


    on(CommunicationChatActions.clearMessages, (state, action) => ({
        ...state,
        currentChat: null,
        currentChatMessages: null,
    })),
    on(CommunicationChatActions.signalRAddNewMessageToCurrentChat, (state, action) => {
        let currentChatMessages = state.currentChatMessages as CommunicationChatMessages;
        let currentChat = state.currentChat as CommunicationChat;
        const chat = state.chats?.find((c) => c.id === action.payload.chatId);
        const currentChatTab = state.chats?.find((c) => c.id === state.currentChat?.id);
        const chats: CommunicationChat[] = [];
        if (!chat) {
            return {
                ...state,
            };
        }

        if (currentChatTab && currentChatTab.id !== chat?.id) {
            chats.push(currentChatTab);
        }

        if (chat) {
            const updatedChat = Helper.deepCopy <CommunicationChat>(chat);
            updatedChat.lastMessage = action.payload;

            if (currentChatTab?.id !== chat?.id) {
                updatedChat.unreadCount++;
            } else {
                updatedChat.lastReadMessageId = action.payload.messageId;
            }

            chats.push(updatedChat);
        }

        if (chats.length) {
            const newChatList = state.chats?.filter((chatFromList) => !chats
                .map((updatedChat) => updatedChat.id)
                .includes(chatFromList.id));

            if (newChatList) {
                chats.push(...newChatList);
            }
        }

        if (currentChatTab?.id === action.payload.chatId) {
            currentChatMessages = {
                ...currentChatMessages,
                messages: [...currentChatMessages?.messages, action.payload],
            };

            currentChat = {
                ...currentChat,
                lastReadMessageId: action.payload.messageId,
            };
        }


        return {
            ...state,
            chats,
            currentChatMessages,
            currentChat,
        };
    }),
    on(CommunicationChatActions.signalRAddNewChat, (state, action) => {
        if (!state.chats?.some((chat) => chat.secondaryTargetKey === action.payload.secondaryTargetKey || //Tournament chat does not have secondaryTargetKey
            chat.primaryTargetKey === action.payload.secondaryTargetKey)) {
            return state;
        }

        return {
            ...state,
            chats: [...(state.chats as CommunicationChat[]), action.payload],
        };
    }),
    on(CommunicationChatActions.signalRUpdateMessageInCurrentChat, (state, action) => {
        let currentChatMessages = state.currentChatMessages as CommunicationChatMessages;
        let currentChat = state.currentChat as CommunicationChat;

        const currentChatUpdatedMessage = state.currentChatMessages?.messages
            .map(message => {
                if (message.messageId === action.payload.messageId) {
                    message = action.payload;
                }
                return message
            }) || [];
        const chat = state.chats?.find((c) => c.id === action.payload.chatId);
        const currentChatTab = state.chats?.find((c) => c.id === state.currentChat?.id);
        const chats: CommunicationChat[] = [];

        if (!chat) {
            return {
                ...state,
            };
        }

        if (currentChatTab && currentChatTab.id !== chat?.id) {
            chats.push(currentChatTab);
        }

        if (chat) {
            const updatedChat = Helper.deepCopy <CommunicationChat>(chat);
            updatedChat.lastMessage = action.payload;

            if (currentChatTab?.id !== chat?.id) {
                updatedChat.unreadCount++;
            } else {
                updatedChat.lastReadMessageId = action.payload.messageId;
            }

            chats.push(updatedChat);
        }

        if (chats.length) {
            const newChatList = state.chats?.filter((chatFromList) => !chats
                .map((updatedChat) => updatedChat.id)
                .includes(chatFromList.id));

            if (newChatList) {
                chats.push(...newChatList);
            }
        }

        if (currentChatTab?.id === action.payload.chatId) {
            currentChatMessages = {
                ...currentChatMessages,
                messages: [...currentChatUpdatedMessage],
            };

            currentChat = {
                ...currentChat,
                lastReadMessageId: action.payload.messageId,
            };
        }

        return {
            ...state,
            chats,
            currentChatMessages,
            currentChat,
        };
    }),


    on(CommunicationChatActions.signalRDeleteMessageInCurrentChat, (state, action) => {
        let currentChatMessages = state.currentChatMessages as CommunicationChatMessages;
        let currentChat = state.currentChat as CommunicationChat;
        const chat = state.chats?.find((c) => c.id === action.payload.chatId);
        const currentChatTab = state.chats?.find((c) => c.id === state.currentChat?.id);
        const chats: CommunicationChat[] = [];
        const currentChatUpdatedMessage = state.currentChatMessages?.messages
            .filter(message => message.messageId !== action.payload.messageId) || [];
        if (!chat) {
            return {
                ...state,
            };
        }

        if (currentChatTab && currentChatTab.id !== chat?.id) {
            chats.push(currentChatTab);
        }

        if (chat) {
            const updatedChat = Helper.deepCopy <CommunicationChat>(chat);
            updatedChat.lastMessage = action.payload;

            if (currentChatTab?.id !== chat?.id) {
                updatedChat.unreadCount++;
            } else {
                updatedChat.lastReadMessageId = action.payload.messageId;
            }

            chats.push(updatedChat);
        }

        if (chats.length) {
            const newChatList = state.chats?.filter((chatFromList) => !chats
                .map((updatedChat) => updatedChat.id)
                .includes(chatFromList.id));

            if (newChatList) {
                chats.push(...newChatList);
            }
        }

        if (currentChatTab?.id === action.payload.chatId) {
            currentChatMessages = {
                ...currentChatMessages,
                messages: [...currentChatUpdatedMessage],
            };

            currentChat = {
                ...currentChat,
                lastReadMessageId: action.payload.messageId,
            };
        }

        return {
            ...state,
            chats,
            currentChatMessages,
            currentChat,
        };
    }),


    on(CommunicationChatActions.signalRChatCategoryUpdated, (state, action) => {
        const chatIndex = state.chats?.findIndex((chat) => chat.id === action.payload.chatId);

        if (!chatIndex || (chatIndex && chatIndex < 0)) {
            return {
                ...state,
            };
        }

        const chats = Helper.deepCopy <CommunicationChat[]>(state.chats);
        chats[chatIndex].category = action.payload.category;

        return {
            ...state,
            chats,
        };
    }), on(CommunicationChatActions.signalRSaveLastReadMessage, (state, action) => {
        const chats = Helper.deepCopy <CommunicationChat[]>(state.chats);

        chats.forEach((chat) => {
            if (chat.id === action.payload.chatId) {
                chat.unreadCount = 0;
                chat.lastReadMessageId = action.payload.messageId;
            }
        });

        return {
            ...state,
            chats,
        };
    }));
